module.exports = __webpack_public_path__ + "img/ico_cs02.782031bf.svg";